/**
 * Lightweight heuristics to extract candidate contact details from raw
 * resume text (client-side preview only — the user can edit every field).
 */

const EMAIL_RE = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/;
const PHONE_RE =
  /(?:\+?\d{1,3}[\s.-]?)?(?:\(\d{2,4}\)[\s.-]?)?\d{3}[\s.-]?\d{3,4}[\s.-]?\d{0,4}/;

/** Words that usually mean a line is a heading, not a person's name. */
const NON_NAME_WORDS =
  /resume|curriculum|vitae|profile|summary|objective|experience|education|contact|skills|@|http/i;

export function parseCandidateInfo(text) {
  const result = { name: "", email: "", phone: "" };
  if (!text || typeof text !== "string") return result;

  const emailMatch = text.match(EMAIL_RE);
  if (emailMatch) result.email = emailMatch[0];

  const phoneMatch = text.match(PHONE_RE);
  if (phoneMatch && phoneMatch[0].replace(/\D/g, "").length >= 7) {
    result.phone = phoneMatch[0].trim();
  }

  // Name: first short line near the top that looks like "First Last".
  const lines = text
    .split(/\n/)
    .map((l) => l.trim())
    .filter(Boolean)
    .slice(0, 10);
  for (const line of lines) {
    if (NON_NAME_WORDS.test(line)) continue;
    const words = line.split(/\s+/);
    if (words.length >= 2 && words.length <= 4 && line.length <= 60) {
      const looksLikeName = words.every((w) =>
        /^[A-ZÀ-Þ][A-Za-zÀ-ÿ'’.-]*$/.test(w)
      );
      if (looksLikeName) {
        result.name = line;
        break;
      }
    }
  }
  return result;
}
